(() => {
  function initialise(root) {
    if (!root || root.dataset.csReady === 'true') return;
    root.dataset.csReady = 'true';

    const toggle = root.querySelector('[data-cs-menu-toggle]');
    const label = root.querySelector('[data-cs-menu-label]');
    const menu = root.querySelector('[data-cs-mobile-menu]');
    if (!toggle || !menu) return;

    const setOpen = (open, restoreFocus) => {
      toggle.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      if (label) label.textContent = open ? 'CLOSE' : 'MENU';
      document.body.classList.toggle('cs-menu-open', open);
      if (!open && restoreFocus) toggle.focus();
    };

    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true', false);
    });

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setOpen(false, false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false, true);
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1100 && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false, false);
      }
    });
  }

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-cs-header]').forEach(initialise);
  };

  initialiseAll();
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
